module.exports = __webpack_public_path__ + "img/159.0d854e8d.jpg";